import React from 'react';

const PageTitle = ({ title }) => {
  return <div className="flex w-full uppercase text-sm sm:text-base md:text-2xl ">{title}</div>;
};

export default PageTitle;
